import React from 'react'
import PropTypes from 'prop-types'
import './PageLayout.scss'

export const PageLayout = ({ children }) => (
  	<div>
      	{children}
  	</div>
)
PageLayout.propTypes = {
  children: PropTypes.node,
}

export default PageLayout


// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js